import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/lib/css-base'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import Button from '~root/./src/components/Button.vue?shadow'
window.customElements.define('component-button', wrap(Vue, Button))

import Calculator from '~root/./src/components/Calculator.vue?shadow'
window.customElements.define('component-calculator', wrap(Vue, Calculator))